
import { Component, Prop, Vue } from "vue-property-decorator";
import RenderNothing from "@/components/RenderNothing.vue";

@Component({
  name: "PortfolioPositionsTopFlop",
  components: { RenderNothing },
})
export default class Portfolio extends Vue {
  @Prop({ type: String, required: false, default: "de" })
  private readonly locale!: string;

  @Prop({ type: String, required: true })
  private readonly id!: string;

  @Prop({ type: String, required: false, default: "top" })
  private readonly type!: string;

  @Prop({ type: Number, required: false, default: 3 })
  private readonly maxItems!: number;

  public onTableRowClick(payload: object) {
    window.dispatchEvent(
      new CustomEvent("portfolio-top-flop-table-row-clicked", {
        detail: payload,
      })
    );
  }
}
